(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-size-diagnosis"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SIZE_CHART = [
      { au: 'AU6', jp: '5号 / XS', bust: 82, waist: 62, hip: 92 },
      { au: 'AU8', jp: '7号 / S', bust: 84.5, waist: 64.5, hip: 94.5 },
      { au: 'AU10', jp: '9号 / M', bust: 87, waist: 67, hip: 97 },
      { au: 'AU12', jp: '11号 / L', bust: 92, waist: 72, hip: 102 },
      { au: 'AU14', jp: '13号 / XL', bust: 97, waist: 77, hip: 107 },
      { au: 'AU16', jp: '15号 / 2L', bust: 102, waist: 82, hip: 112 },
      { au: 'AU18', jp: '17号 / 3L', bust: 107, waist: 87, hip: 117 }
    ];

    function nearestByKey(value, key) {
      var best = null;
      var bestDiff = Infinity;
      SIZE_CHART.forEach(function (row) {
        var diff = Math.abs(row[key] - value);
        if (diff < bestDiff) {
          bestDiff = diff;
          best = row;
        }
      });
      return best;
    }

    function nearestOverall(bust, hip, waist) {
      var best = null;
      var bestScore = Infinity;
      SIZE_CHART.forEach(function (row) {
        var score = Math.abs(row.bust - bust) + Math.abs(row.hip - hip);
        if (typeof waist === 'number' && !isNaN(waist)) {
          score += Math.abs(row.waist - waist) * 0.5;
        }
        if (score < bestScore) {
          bestScore = score;
          best = row;
        }
      });
      return best;
    }

    function init() {
      var form = document.getElementById('bb-diag-form');
      var result = document.getElementById('bb-diag-result');
      if (!form || !result) return;

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var bust = parseFloat(document.getElementById('bb-diag-bust').value);
        var hip = parseFloat(document.getElementById('bb-diag-hip').value);
        var waistRaw = document.getElementById('bb-diag-waist').value;
        var waist = waistRaw === '' ? NaN : parseFloat(waistRaw);

        if (isNaN(bust) || isNaN(hip)) return;

        var overall = nearestOverall(bust, hip, waist);
        var bustSize = nearestByKey(bust, 'bust');
        var hipSize = nearestByKey(hip, 'hip');

        var html = '';
        html += '<p class="bb-diag-result-size">おすすめサイズ： ' + overall.au + '</p>';
        html += '<p class="bb-diag-result-jp">（日本サイズ目安： ' + overall.jp + '）</p>';

        if (bustSize.au !== hipSize.au) {
          html +=
            '<p class="bb-diag-result-note">トップスはバストに近い ' +
            bustSize.au +
            '、ボトムスはヒップに近い ' +
            hipSize.au +
            ' が目安です。デザインによってフィット感が異なるため、上下で迷う場合は大きい方のサイズ、またはメール相談でのご確認をおすすめします。</p>';
        } else {
          html +=
            '<p class="bb-diag-result-note">トップス・ボトムスとも ' +
            overall.au +
            ' が目安です。デザインによって多少差が出る場合がありますので、商品ページのサイズ表もあわせてご確認ください。</p>';
        }

        result.innerHTML = html;
        result.hidden = false;
        result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-styling-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var filters = document.querySelectorAll('.bb-gallery-filter');
      var tiles = document.querySelectorAll('.bb-gallery-tile');
      if (!filters.length || !tiles.length) return;

      filters.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-filter');
          filters.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          tiles.forEach(function (tile) {
            if (target === 'all' || tile.getAttribute('data-category') === target) {
              tile.style.display = '';
            } else {
              tile.style.display = 'none';
            }
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
